import React from 'react';

export default function TrendDirection(props) {
    return <div className={`trend-direction description ${props.direction}`}>
        <span className="icon fa" />
        <div>{props.children}</div>
    </div>
}